const placeholders = {
  hotelName: '@[hotelName](__hotelName__)',
  guestName: '@[guestName](__guestName__)',
  guestLastName: '@[guestLastName](__guestLastName__)',
  inviteLink: '@[inviteLink](__inviteLink__)',
  guestNameReplacement: '⌘⌘@[guestName](__guestName__)⌘⌘',
  inviteLinkReplacement: '⌘⌘@[inviteLink](__inviteLink__)⌘⌘',
  guestLastNameReplacement: '⌘⌘@[guestLastName](__guestLastName__)⌘⌘',
  inviteUrl: 'on.directful/hsa88',
  guestNameValue: 'firstName',
  guestLastNameValue: 'lastName'
}

export default placeholders
